export const cron_jobs = {
  documentTitle: "Cron Jobs",
  title: "Cron Jobs",
  empty: "No cron jobs found.",
};
